import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-in-evidenza',
  templateUrl: './in-evidenza.component.html',
  styleUrls: ['./in-evidenza.component.scss']
})
export class InEvidenzaComponent implements OnInit {

  pageTitle = "In Evidenza | Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere"
  shareImg = "blog/masthead-blog.jpg";

  constructor(private seo: SEOService) {}

  ngOnInit() { 
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  // I NUOVI ARTICOLI VANNO INSERITI IN TESTA!
  articles = [
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza/_4/in-evidenza_4_home.jpg",
      title: "Riccardo Ferrero Leone con Giorgio Calabrese",
      desc: "Il dottor Riccardo Ferrero Leone spiega la validità della dieta chetogenica al professor Giorgio Calabrese.",
      url: "in-evidenza/leone-con-calabrese",
      cta: "Continua a leggere"
    },
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza/_3/in-evidenza_3_home.jpg",
      title: "Amido Resistente - Un nutriente molto prezioso per la nostra salute",
      desc: "L’amido resistente (o resistant starch RS) è considerato una fibra alimentare che sfugge alla digestione e all’assorbimento intestinale ...",
      url: "in-evidenza/amido-resistente",
      cta: "Continua a leggere"
    },
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza/_2/in-evidenza_2_home.jpg",
      title: "Donazione Kerala",
      desc: "A giugno scorso il dottor Riccardo Ferrero Leone ha donato un ventilatore polmonare ad alto flusso con controllo automatico delle apnee ...",
      url: "in-evidenza/donazione-kerala",
      cta: "Continua a leggere"
    },
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza/_1/in-evidenza_1_home.jpg",
      title: "Ferrero Leone Alta Formazione",
      desc: "Il dottor Ferrero Leone ha ricevuto dal Ministro della Salute e dell’Ambiente della Repubblica dell’Iraq ...",
      url: "in-evidenza/ferrero-leone-alta-formazione",
      cta: "Continua a leggere"
    },
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza/_0/in-evidenza_0_home.jpg",
      title: "L-Immuno",
      desc: "È finalmente disponibile la formulazione <strong>antiossidante</strong> con <strong>Lattoferrina</strong> e <strong>Quercetina</strong> che protegge e rinforza il tuo sistema immunitario, utile per tutti ...",
      url: "in-evidenza/l-immuno",
      cta: "Continua a leggere"
    },
  ]
}
